module.exports = __webpack_public_path__ + "static/media/heart-broken.dd4bd60d.svg";